<template>
  <div class="login">
    <div class="login__wrapper">
      <div class="login__title">
        Login
      </div>
      <div class="login__text">
        Sign In to your account
      </div>
      <form class="login__form" @submit="submit">
        <div class="login__error" v-if="error">
          Login Failed!
        </div>
        <input type="text" class="login__input" v-model="email" placeholder="username">
        <input type="password" class="login__input" v-model="password" placeholder="password">
        <button class="login__submit" :class="loading && 'loading'">Login</button>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        email: '',
        password: '',
        loading: false,
        error: false,
      }
    },
    methods: {
      async submit(e) {
        e.preventDefault();
        e.stopPropagation();
        this.loading = true;
        try {
          const res = await this.axios.post(`/api/auth`, { user: this.email, password: this.password });
          if (!res.token) {
            this.loginFailed();
            return;
          }
          const authtoken = btoa(this.email + ':' + this.password);
          window.localStorage.setItem('authtoken', authtoken);
          this.error = false;

          this.$router.replace('/');
        } catch (e) {
          this.loginFailed();
        }
        this.loading = false;
      },

      loginFailed() {
        window.localStorage.removeItem('authtoken');
        this.error = true;
      },
    },
  }
</script>

<style lang="scss">
  .login {
    font-family: 'Montserrat', sans-serif;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #eff0f2;
    &__wrapper {
      background-color: #fff;
      border: 1px solid #9aa1af;
      border-radius: 5px;
      padding: 50px;
    }
    &__title {
      font-size: 32px;
      font-weight: 600;
      color: #00234e;
      margin-bottom: 10px;
    }
    &__text {
      font-size: 16px;
      color: #9aa1af;
      margin-bottom: 15px;
    }
    &__form {

    }
    &__input {
      display: block;
      width: 300px;
      border: 1px solid #9aa1af;
      background-color: #ffffff;
      font-size: 16px;
      color: #9aa1af;
      padding: 10px 20px;
      border-radius: 4px;
      margin-bottom: 20px;
      font-family: 'Montserrat', sans-serif;
      &:focus, &:active, &:hover {
        border: 1px solid #9aa1af;
        outline: none;
      }
    }
    &__submit {
      border-radius: 4px;
      background-color: #00234e;
      border: 1px solid #9aa1af;
      padding: 10px 25px;
      font-size: 16px;
      color: #fff;
      font-family: 'Montserrat', sans-serif;
      cursor: pointer;
      &:hover, &:active, &:focus {
        outline: none;
        border: 1px solid #9aa1af;
      }
      &.loading {
        opacity: .5;
        pointer-events: none;
        cursor: not-allowed;
      }
    }
    &__error {
      margin-bottom: 15px;
      font-size: 14px;
      color: #f61f7e;
    }
  }
</style>
